import { createContext } from 'react';

export interface AccountSalaryKeyContextValue {
  unlocked: boolean;
  /** Opens the dialog. Does nothing when already unlocked. */
  requestUnlock: () => void;
}

/**
 * Kept in its own module, apart from the provider that fills it, so the provider file
 * exports only components — otherwise fast refresh stops working for it
 * (react-refresh/only-export-components).
 */
export const AccountSalaryKeyContext = createContext<AccountSalaryKeyContextValue | null>(null);
